import instanceAxios from './axiosConfig';
import { URL} from '../utility/util';

const storeQueueDetails = async (queueDetails ) => {
    let req = URL.PARAMS.STORE_QUEUE_DETAILS;
    req.data.InitialContactID = queueDetails[0].InitialContactId  
       req.data.queueDetails        = queueDetails;
    
    return new Promise((resolve, reject) => {
        instanceAxios.post('/mso-chat', req )
        .then((response) => {
            console.log("Success...")
            resolve(response.data.data);
        })
        .catch(error => {
            console.log("Error...", error)
            reject(error);
        })
    })
  };
  
  export default storeQueueDetails;